<template>
  <div class="price__wrapper">
    <div>
      <span class="" aria-hidden="false" v-if="isOnSale">
        <span id="PriceA11y" class="visually-hidden">Regular price</span>
        <span id="ComparePriceBreak" class="price">{{ activePrice }}</span>
      </span>
      <span v-if="isOnSale" id="ComparePriceA11y" class="visually-hidden"
        >Sale price</span
      >
      <span v-else id="PriceA11y" class="visually-hidden">Regular price</span>
      <span
        id="ProductPriceBreak"
        itemprop="price"
        :content="regPrice"
        class="price"
        :class="{ 'sale-price': isOnSale }"
      >
        {{ regPrice }}
      </span>
    </div>
    <div class="tag__wrapper">
      <span v-if="isOnSale" class="product-discount-percent"
        >{{ deriveDiscount() }}% off</span
      >
      <div class="timeline_wrapper">
        {{  timelineText }}
      </div>
    </div>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "CustomizerPrice",
  props: {
    activePrice: {
      type: String,
    },
    regPrice: {
      type: String,
    },
  },
  data() {
    return {
      EMPTY_PRICES: ["$0.00", "$0"],
    };
  },

  computed: {
    ...mapGetters({
      activeTimeline: "shipping/getActiveTimeline",
      isDecideLater: "fabrics/isDecideLater"
    }),
    isOnSale() {
      if (!this.EMPTY_PRICES.includes(this.activePrice)) {
        if (this.activePrice !== this.regPrice) {
          return true;
        }
      }
      return false;
    },
    timelineText() {
      let shippingText = "Made in "
      let weeks = parseInt(this.activeTimeline) / 7
      if (weeks > 0) {
        shippingText += `${Math.ceil(weeks)} Weeks`
      } else {
        shippingText += `${this.activeTimeline} Days`
      }
      if (this.isDecideLater) {
        shippingText = 'TBD'
      }
      return shippingText
    }
  },
  methods: {
    deriveDiscount() {
      const activePrice = parseFloat(this.activePrice.replaceAll(/[$,]/gm, ""));
      const normalPrice = parseFloat(this.regPrice.replaceAll(/[$,]/gm, ""));
      if (!isNaN(normalPrice) && !isNaN(activePrice)) {
        return Math.round(((normalPrice - activePrice) / normalPrice) * 100);
      }
      return "";
    },
  },
};
</script>
<style scoped>
.price {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  color: var(--text-color, #2C2B2A);
}
.price.sale-price {
  margin-left: 5px;
  position: relative;
  font-weight: 400;
  text-decoration: line-through;
}
.product-discount-percent {
  /* margin-left: 5px; */
  padding: 4px 10px;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  background-color: #EAF5C0;
  text-transform: uppercase;
  display: inline-block;
}
.price__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.tag__wrapper {
  display: flex;
  gap: 5px;
}
.timeline_wrapper {
  color: var(--White, #FFF);
  font-family: Visby;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-transform: uppercase;
  background: var(--Ocean-Teal-100, #8CAAB3);
  padding: 4px 10px;
}
@media screen and (min-width: 1024px) {
  .price__wrapper {
    justify-content: flex-start;
    gap: 5px;
  }
}
</style>
